"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  dialogMessage: "It appears that the link you're attempting to access originates from a different country than your current location. Please choose location.",
  dialogTitle: 'Looks like you are trying to access Oriflame {foreignCountry} from {homeCountry}.',
  foreignCountryButton: 'Go to Oriflame {foreignCountry}',
  homeCountryButton: 'Continue to {homeCountry}'
};
const translationsNamespace = exports.translationsNamespace = 'geolocation-popup';